import { DetailsComponent } from './details.component';

export default [
  { path: '', component: DetailsComponent },
];



// WEBPACK FOOTER //
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/details/details-routing.ts